import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ContCasosUsoSection,
  TitleCasosUso,
  DescCasosUso,
  SubtitleCasosUso,
  CasosUsoGrid,
  CasoUsoCard,
  CasoUsoContent,
  CasoUsoIcon,
  CasoUsoTitle,
  CasoUsoDescription,
  DescriptionTitle,
  DescriptionText,
} from './CoreBancarioCasosUso.styles';

import MoneyIcon from '../../assets/images/CoreBankingModulesImages/useCase/Money.svg';
import ArhiveIcon from '../../assets/images/CoreBankingModulesImages/useCase/Arhive_alt_export.svg';
import WaterfallIcon from '../../assets/images/CoreBankingModulesImages/useCase/Waterfall.svg';
import CardIcon from '../../assets/images/CoreBankingModulesImages/useCase/Card.svg';
import ChieldIcon from '../../assets/images/CoreBankingModulesImages/useCase/Chield_alt.svg';
import BitcoinIcon from '../../assets/images/CoreBankingModulesImages/useCase/Bitcoin.svg';

const casosUsoData = [
  {
    id: 1,
    title: 'Crédito',
    description: 'Administra créditos simples, revolventes, bullet, puente o personalizados con flujos automáticos y total flexibilidad.',
    icon: MoneyIcon,
  },
  {
    id: 2,
    title: 'Arrendamiento',
    description: 'Gestiona contratos de arrendamiento de forma eficiente con control total sobre pagos, vencimientos y renovaciones.',
    icon: ArhiveIcon,
  },
  {
    id: 3,
    title: 'Factoraje',
    description: 'Optimiza tus operaciones de factoraje con automatización completa desde la originación hasta la recuperación.',
    icon: WaterfallIcon,
  },
  {
    id: 4,
    title: 'Emisión de Tarjeta',
    description: 'Emite y administra tarjetas de débito y crédito con control total sobre límites, transacciones y seguridad.',
    icon: CardIcon,
  },
  {
    id: 5,
    title: 'Inversión',
    description: 'Administra portafolios de inversión con seguimiento en tiempo real y reportes automatizados para tus clientes.',
    icon: ChieldIcon,
  },
  {
    id: 6,
    title: 'Ahorro',
    description: 'Ofrece productos de ahorro flexibles con tasas competitivas y control total sobre las cuentas de tus clientes.',
    icon: MoneyIcon,
  },
  {
    id: 7,
    title: 'Activos Virtuales',
    description: 'Gestiona activos digitales y criptomonedas con la seguridad y el cumplimiento normativo que tu negocio requiere.',
    icon: BitcoinIcon,
  },
];

export const CoreBancarioCasosUso = () => {
  const { t } = useTranslation();
  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <ContCasosUsoSection>
      <TitleCasosUso>
        {t('Tus productos financieros con un Core que crece contigo')}
      </TitleCasosUso>
      <DescCasosUso>
        {t('La transformación de tu empresa comienza con la tecnología adecuada: una plataforma modular que digitaliza y automatiza tu operación de principio a fin.')}
      </DescCasosUso>

      <SubtitleCasosUso>
        {t('Casos de uso')}
      </SubtitleCasosUso>
      <CasosUsoGrid>
        {casosUsoData.map((caso) => (
          <CasoUsoCard
            key={caso.id}
            onMouseEnter={() => setHoveredCard(caso.id)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CasoUsoContent showDescription={hoveredCard === caso.id}>
              <CasoUsoIcon>
                <img src={caso.icon} alt={t(caso.title)} />
              </CasoUsoIcon>
              <CasoUsoTitle>{t(caso.title)}</CasoUsoTitle>
            </CasoUsoContent>

            <CasoUsoDescription showDescription={hoveredCard === caso.id}>
              <DescriptionTitle>{t(caso.title)}</DescriptionTitle>
              <DescriptionText>{t(caso.description)}</DescriptionText>
            </CasoUsoDescription>
          </CasoUsoCard>
        ))}
      </CasosUsoGrid>
    </ContCasosUsoSection>
  );
};
